import React from 'react'
import PropTypes from 'prop-types'

import './GallerySliderArrow.css'

const LEFT_ARROW = 'left'
const RIGHT_ARROW = 'right'

const GallerySliderArrow = ({ arrow, onClick }) => (
    <div className={`gallery-slider-arrow gallery-slider-arrow--${arrow}`} onClick={onClick}>
        <div className={`gallery-slider-arrow__arrow gallery-slider-arrow__arrow--${arrow}`} />
    </div>
)

GallerySliderArrow.propTypes = {
    isLeft: PropTypes.bool,
    onClick: PropTypes.func.isRequired
}

GallerySliderArrow.defaultProps = {
    arrow: LEFT_ARROW
}

export { GallerySliderArrow, LEFT_ARROW, RIGHT_ARROW }
